<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dealerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dealerProfile.pageTitle'),
            href: '/dealer-profiles'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-6">
              <div class="row mb-2">
                <div class="col-md-6">
                  <label class="required ts-text-xs">
                    {{
                    $t('dealerProfile.dealerName')
                    }}
                  </label>
                  <input type="text" class="form-control" v-model.trim="model.dealer_name" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('dealer_name')"
                  >{{ errors.first('dealer_name') }}</div>
                </div>
                <div class="col-md-6">
                  <label class="required ts-text-xs">
                    {{
                    $t('dealerProfile.ownerName')
                    }}
                  </label>
                  <input type="text" class="form-control" v-model.trim="model.owner_name" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('owner_name')"
                  >{{ errors.first('owner_name') }}</div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <label class="required ts-text-xs">
                    {{
                    $t('dealerProfile.type')
                    }}
                  </label>
                  <a-select
                    v-model="model.dealer_type_id"
                    :options="dealer_type"
                    style="width:100%"
                    @change="dealerTypeChange"
                  ></a-select>
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('dealer_type_id')"
                  >{{ errors.first('dealer_type_id') }}</div>
                </div>
                <div class="col-md-6">
                  <label class="ts-text-xs">
                    {{
                    $t('dealerProfile.parent')
                    }}
                  </label>
                  <a-select
                    v-model="model.parent_dealer_id"
                    :options="parent_dealer"
                    :disabled="isSupperDealer"
                    style="width:100%"
                  ></a-select>
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('parent_dealer_id')"
                  >{{ errors.first('parent_dealer_id') }}</div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <label class="required ts-text-xs">
                    {{
                    $t('dealerProfile.primaryContact')
                    }}
                  </label>
                  <input type="text" class="form-control" v-model="model.primary_contact" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('primary_contact')"
                  >{{ errors.first('primary_contact') }}</div>
                </div>
                <div class="col-md-6">
                  <label class="ts-text-xs">
                    {{
                    $t('dealerProfile.secondaryContact')
                    }}
                  </label>
                  <input type="text" class="form-control" v-model="model.secondary_contact" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('secondary_contact')"
                  >{{ errors.first('secondary_contact') }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="ts-text-xs required">
                    {{
                    $t('dealerProfile.allowCredit')
                    }}
                  </label>
                  <input type="number" class="form-control" v-model.number="model.credit_allow" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('credit_allow')"
                  >{{ errors.first('credit_allow') }}</div>
                </div>
                <div class="col-md-6 md:ts-mt-4" v-if="model.dealer_type_id == 1">
                  <ts-checkbox v-model="model.is_under_company">
                    {{
                    $t('dealerProfile.underCompany')
                    }}
                  </ts-checkbox>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="ts-text-xs required">
                    {{
                    $t('dealerProfile.payoutLimit')
                    }}
                  </label>
                  <input type="number" class="form-control" v-model.number="model.payout_limit" />
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('payout_limit')"
                  >{{ errors.first('payout_limit') }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <form>
                    <fieldset>
                      <legend class="text-primary">{{ $t('dealerProfile.idPassport') }}</legend>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.idType')
                            }}
                          </label>
                          <a-select v-model="model.id_type">
                            <a-select-option value="id">Identity Card</a-select-option>
                            <a-select-option value="passport">Passport</a-select-option>
                          </a-select>
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('id_type')"
                          >{{ errors.first('id_type') }}</div>
                        </div>
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.idPassportNo')
                            }}
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            v-model.number="model.id_passport_no"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('id_passport_no')"
                          >{{ errors.first('id_passport_no') }}</div>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.issuedDate')
                            }}
                          </label>
                          <a-date-picker
                            style="width:100%"
                            format="DD-MM-YYYY"
                            v-model="model.issued_date"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('issued_date')"
                          >{{ errors.first('issued_date') }}</div>
                        </div>
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.expiredDate')
                            }}
                          </label>
                          <a-date-picker
                            style="width:100%"
                            format="DD-MM-YYYY"
                            v-model="model.expiry_date"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('issued_date')"
                          >{{ errors.first('issued_date') }}</div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.issuedAt')
                            }}
                          </label>
                          <textarea v-model.trim="model.issued_at" rows="1" class="form-control"></textarea>
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('issued_at')"
                          >{{ errors.first('issued_at') }}</div>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <drop-file
                            ref="font_photo"
                            :placeholder="$t('dealerProfile.frontSide')"
                            @file="file => (model.front_photo = file)"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('front_photo')"
                          >{{ errors.first('front_photo') }}</div>
                        </div>
                        <div class="col-md-6">
                          <drop-file
                            ref="back_photo"
                            :placeholder="$t('dealerProfile.backSide')"
                            @file="file => (model.back_photo = file)"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('back_photo')"
                          >{{ errors.first('back_photo') }}</div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mb-3">
                <div class="col-md-12">
                  <form>
                    <fieldset>
                      <legend class="text-primary">{{ $t('dealerProfile.address') }}</legend>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <div class="col-md-12 mb-2">
                            <label class="ts-text-xs">
                              {{
                              $t('dealerProfile.coordinate')
                              }}
                            </label>
                            <input type="text" class="form-control" v-model="model.geo_location" readonly />
                          </div>
                          <div class="col-md-12">
                            <label class="ts-text-xs">
                              {{
                              $t('dealerProfile.address')
                              }}
                            </label>
                            <textarea
                              rows="5"
                              class="form-control"
                              v-model.trim="model.dealer_address"
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <GmapMap
                            :center="startLocation"
                            :zoom="7"
                            map-type-id="roadmap"
                            style="width: 100%; height: 100%"
                            @click="getLat"
                          >
                            <gmap-marker
                              v-for="(item, key) in coordinates"
                              :key="key"
                              :position="item"
                            />
                          </GmapMap>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-md-4">
                          <drop-file
                            ref="photo1"
                            :placeholder="$t('dealerProfile.photo1')"
                            @file="file => (model.photo1 = file)"
                          />
                        </div>
                        <div class="col-md-4">
                          <drop-file
                            ref="photo2"
                            :placeholder="$t('dealerProfile.photo2')"
                            @file="file => (model.photo2 = file)"
                          />
                        </div>
                        <div class="col-md-4">
                          <drop-file
                            ref="photo3"
                            :placeholder="$t('dealerProfile.photo3')"
                            @file="file => (model.photo3 = file)"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <form>
                    <fieldset>
                      <legend class="text-primary">{{ $t('dealerProfile.commission') }}</legend>
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.topUp')
                            }}
                          </label>
                          <input
                            type="number"
                            step="any"
                            class="form-control"
                            v-model.number="model.topup_commission_rate"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('topup_commission_rate')"
                          >{{ errors.first('topup_commission_rate') }}</div>
                        </div>
                        <div class="col-md-6">
                          <label class="required ts-text-xs">
                            {{
                            $t('dealerProfile.payOut')
                            }}
                          </label>
                          <input
                            type="number"
                            step="any"
                            class="form-control"
                            v-model.number="model.payout_commission_rate"
                          />
                          <div
                            class="validate ts-text-xs"
                            v-if="errors.has('payout_commission_rate')"
                          >{{ errors.first('payout_commission_rate') }}</div>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
              <!-- <div class="row ts-mt-3">
                <div class="col-md-12">
                  <UserLogin v-model="model" :validate="errors" />
                </div>
              </div>-->
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button
                @click.prevent="$router.push({ name: 'dealer-profile' })"
              >{{ $t('cancel') }}</ts-button>
              <ts-button
                class="ml-2 mr-2"
                color="primary"
                outline
                :waiting="waiting_new"
                @click.prevent="onSaveAddNew"
              >{{ $t('save_add_new') }}</ts-button>
              <ts-button
                :waiting="waiting"
                color="primary"
                @click.prevent="onStore"
              >{{ $t('save') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import DropFile from './components/drop-file'
import UserLogin from './components/user-login'

export default {
  name: 'dealerProfileFormCreate',
  components: {
    DropFile,
    UserLogin
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      dealer_type: [],
      parent_dealer: [],
      model: {
        dealer_id: null,
        dealer_name: null,
        dealer_address: null,
        geo_location: null,
        photo1: null,
        photo2: null,
        photo3: null,
        dealer_type_id: null,
        parent_dealer_id: null,
        owner_name: null,
        primary_contact: null,
        secondary_contact: null,
        id_type: null,
        id_passport_no: null,
        issued_date: null,
        expiry_date: null,
        issued_at: null,
        front_photo: null,
        back_photo: null,
        topup_commission_rate: null,
        payout_commission_rate: null,
        is_under_company: false,
        credit_allow: null,
        payout_limit: null,
        user_name: null,
        password: null
      },
      startLocation: {
        lat: 12.460734899627502,
        lng: 103.89190330367092
      },
      coordinates: {
        0: {
          lat: 12.460734899627502,
          lng: 103.89190330367092
        }
      }
    }
  },
  created() {
    this.fetchDealerType()
  },
  computed: {
    isSupperDealer() {
      return this.model.dealer_type_id == 1
    }
  },
  methods: {
    ...mapActions('administrator/dealerProfile', [
      'dealerType',
      'store',
      'parentDealer',
      'commissionRate'
    ]),
    getLat(event) {
      this.coordinates[0].full_name = '111'
      this.coordinates[0].lat = event.latLng.lat()
      this.coordinates[0].lng = event.latLng.lng()
      this.model.geo_location = this.coordinates[0].lat  + ',' + this.coordinates[0].lng
    },
    async fetchDealerType() {
      this.loading = true
      await this.dealerType().then(response => {
        this.dealer_type = response.data.map(el => ({
          value: el.dealer_type_id,
          label: el.dealer_type
        }))
      })
      await this.parentDealer()
        .then(response => {
          this.parent_dealer = response.data.map(el => ({
            value: el.dealer_id,
            label: el.dealer_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onStore() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'dealer-profile' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.dealer_name = null
      this.model.dealer_address = null
      this.model.geo_location = null
      this.model.photo1 = null
      this.model.photo2 = null
      this.model.photo3 = null
      this.model.dealer_type_id = null
      this.model.parent_dealer_id = null
      this.model.owner_name = null
      this.model.primary_contact = null
      this.model.secondary_contact = null
      this.model.id_type = null
      this.model.id_passport_no = null
      this.model.issued_date = null
      this.model.expiry_date = null
      this.model.issued_at = null
      this.model.front_photo = null
      this.model.back_photo = null
      this.model.topup_commission_rate = null
      this.model.payout_commission_rate = null
      this.model.credit_allow = null
      this.model.payout_limit = null

      this.$refs.font_photo.files = []
      this.$refs.back_photo.files = []

      this.$refs.photo3.files = []
      this.$refs.photo2.files = []
      this.$refs.photo1.files = []
    },
    dealerTypeChange(dealer_type_id) {
      this.model.is_under_company = false
      this.model.parent_dealer_id = null
      this.loading = true
      this.commissionRate(dealer_type_id)
        .then(response => {
          if (response.data.length > 0) {
            let data = response.data[0]
            this.model.topup_commission_rate = data.topup_commission_rate
            this.model.payout_commission_rate = data.payout_comission_rate
            this.model.credit_allow = data.credit_allow
            this.model.payout_limit = data.payout_limit
          } else {
            this.model.topup_commission_rate = null
            this.model.payout_commission_rate = null
            this.model.credit_allow = null
            this.model.payout_limit = null
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
